var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('msw-app-title',{attrs:{"name":"mswApptitle"}}),_vm._v(" "),_c('iframe',{staticClass:"training-frame",attrs:{"id":"frame","src":_vm.source}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }